module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-900.woff2?01e9bd16b2374667a28bf9a93cc25970";